import Area from './area'
import Admission from './admission'
import Auth from './auth'
import Beacon from './beacon'
import { APIClient } from '@/infrastructure/network/Legacy/APIClient'

export default class LegacyGateway {
  apiClient: APIClient
  Admission: Admission
  Area: Area
  Auth: Auth
  Beacon: Beacon

  constructor(apiClient: APIClient) {
    this.apiClient = apiClient
    this.Admission = new Admission(apiClient)
    this.Area = new Area(apiClient)
    this.Auth = new Auth(apiClient)
    this.Beacon = new Beacon(apiClient)
  }
}
